//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';
import { PojoSet } from 'pojo-sets';

import { Permissions } from '@models/Permissions';
import { isTruthy } from '@utils/filterPredicates';

import { ICuralateSession } from 'app/basic-session/ICuralateSession';
import { SessionMode } from 'app/moderation-mode/constants/SessionMode';
import { getHasCapabilityOverride } from 'app/moderation-mode/moderationModeDevOverride';

interface ModeDerivationInput {
  hasMergeEnabled: boolean;
  permissions: PojoSet<string>;
  storedMode: SessionMode | undefined;
}

// ShareV2 vendors use the separate Connect moderation instance.
export const getIsModerationMergeEnabled = (
  session: ICuralateSession,
): boolean =>
  !session.client.isShareV2Vendor &&
  isTruthy(session.features[FeatureNames.MediaLibrarySourcedOrganicContent]) &&
  isTruthy(session.features[FeatureNames.BvModeration]) &&
  // TODO: PD-330267 - Remove feature check once ModeratorVibeView is released
  isTruthy(session.features[FeatureNames.ModeratorVibeView]);

export const getIsModeratorCapable = (permissions: PojoSet<string>): boolean =>
  isTruthy(permissions[Permissions.ModerationView]) ||
  getHasCapabilityOverride();

// Revalidate the capability even when the stored mode is Moderator.
export const deriveSessionMode = ({
  hasMergeEnabled,
  permissions,
  storedMode,
}: ModeDerivationInput): SessionMode => {
  if (!hasMergeEnabled || !getIsModeratorCapable(permissions)) {
    return SessionMode.Client;
  }

  return storedMode ?? SessionMode.Client;
};
